/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
/* eslint-disable react/prop-types */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import {
  Button,
  Select,
  MenuItem,
  InputLabel,
  makeStyles,
  Typography,
  Divider,
  CircularProgress,
} from '@material-ui/core';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import SaveIcon from '@material-ui/icons/Save';
import CommentIcon from '@material-ui/icons/Comment';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import Fab from '@material-ui/core/Fab';
import useUpdateCoursePlan from './useUpdateCoursePlan';
import skillTitleServices from '../../../../redux/services/skillTitleServices';
import groupServices from '../../../../redux/services/groupServices';
import { toastSuccess } from '../../../../redux/actions/alertActions';
import DisplayContent from './DisplayContent';
import SpecificSkills from './SpecificSkills';
import NeedsDialog from './NeedsDialog';
import NeedsSelection from './NeedsSelection';
import { generatePDF } from '../generatePdf';
import uiActions from '../../../../redux/actions/uiActions';
import SidebarComment from '../CommentSidebar';
import { Loading } from '../../../../helpers/utils';

const style = {
  margin: 0,
  top: 'auto',
  right: 20,
  bottom: 20,
  left: 'auto',
  zIndex: 99,
  position: 'fixed',
};

const styleComment = {
  margin: 0,
  top: 'auto',
  right: 20,
  bottom: 180,
  left: 'auto',
  zIndex: 99,
  position: 'fixed',
};

const stylepdf = {
  margin: 0,
  top: 'auto',
  right: 20,
  bottom: 100,
  left: 'auto',
  zIndex: 99,
  position: 'fixed',
};

const useStyles = makeStyles({
  top: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
  },
  select: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '10px',
  },
});

const Content = ({
  groupId,
  dataform,
  groupState,
  setSidebarState,
}) => {
  const [level, setLevel] = useState('A1');
  const [language, setLanguage] = useState('EN');
  const [content, setContent] = useState([]);
  const [open, setOpen] = useState(false);
  const [specificSkills, setSpecificSkills] = useState([]);
  const [contentIds, setContentIds] = useState([]);
  const [group, setGroup] = useState({});
  const [loading, setLoading] = useState(false);
  const { updateCoursePlan } = useUpdateCoursePlan();
  const classes = useStyles();

  const [vocPro, setVocPro] = useState({
    logistics: false,
    sales: false,
    marketing: false,
    finance: false,
    legal: false,
    engineering: false,
    production: false,
    quality: false,
    it: false,
    hr: false,
  });

  const [vocInterests, setVocInterests] = useState({
    news: false,
    environment: false,
    economy: false,
    politics: false,
    art: false,
    sport: false,
    travelling: false,
    education: false,
    leisure: false,
  });

  const [vocWork, setVocWork] = useState({
    meetings: false,
    presentations: false,
    negotiations: false,
    emails: false,
    telephoning: false,
  });

  const toogleSidebar = () => {
    setSidebarState();
  };

  const fetchSkills = () => {
    skillTitleServices.getSkillTitles().then((res) => {
      const skillArr = [];
      res.forEach((item) => {
        // getting title in right language => values[indexLanguage]
        const keys = Object.keys(item);
        const values = Object.values(item);
        let indexLanguage;
        keys.forEach((key, index) => {
          if (key === language) {
            indexLanguage = index;
          }
        });
        const functionalSkillsContent = [];
        const languageSkillsContent = [];
        const grammarSkillsContent = [];
        if (item.skills && item.skills.length > 0) {
          item.skills.forEach((skill) => {
            if (skill.level === level) {
              const k = Object.keys(skill);
              const v = Object.values(skill);
              let indexSkillLanguage;
              k.forEach((elem, index) => {
                if (elem === language) {
                  indexSkillLanguage = index;
                }
              });
              if (skill.type === 'functional' && v[indexSkillLanguage] !== undefined && v[indexSkillLanguage].length > 0) {
                const skillObj = {
                  skillId: skill._id,
                  description: v[indexSkillLanguage],
                  type: skill.type,
                };
                if (skill.categories?.includes('vocPro') && group.coursePlan?.vocPro) {
                  skillObj.categories = group.coursePlan.vocPro;
                }
                if (skill.categories?.includes('vocInterests') && group.coursePlan?.vocInterests) {
                  skillObj.categories = group.coursePlan.vocInterests;
                }
                if (skill.categories?.includes('vocWork') && group.coursePlan?.vocWork) {
                  skillObj.categories = group.coursePlan.vocWork;
                }
                functionalSkillsContent.push(skillObj);
              } else if (skill.type === 'language' && v[indexSkillLanguage] !== undefined && v[indexSkillLanguage].length > 0) {
                const skillObj = {
                  skillId: skill._id,
                  description: v[indexSkillLanguage],
                  type: skill.type,
                };
                if (skill.categories?.includes('vocPro') && group.coursePlan?.vocPro?.length > 0) {
                  skillObj.categories = group.coursePlan.vocPro;
                }
                if (skill.categories?.includes('vocInterests') && group.coursePlan?.vocInterests?.length > 0) {
                  skillObj.categories = group.coursePlan.vocInterests;
                }
                if (skill.categories?.includes('vocWork') && group.coursePlan?.vocWork?.length > 0) {
                  skillObj.categories = group.coursePlan.vocWork;
                }
                languageSkillsContent.push(skillObj);
              } else if (skill.type === 'grammar' && v[indexSkillLanguage] !== undefined && v[indexSkillLanguage].length > 0) {
                const skillObj = {
                  skillId: skill._id,
                  description: v[indexSkillLanguage],
                  type: skill.type,
                };
                if (skill.categories?.includes('vocPro') && group.coursePlan?.vocPro?.length > 0) {
                  skillObj.categories = group.coursePlan.vocPro;
                }
                if (skill.categories?.includes('vocInterests') && group.coursePlan?.vocInterests?.length > 0) {
                  skillObj.categories = group.coursePlan.vocInterests;
                }
                if (skill.categories?.includes('vocWork') && group.coursePlan?.vocWork?.length > 0) {
                  skillObj.categories = group.coursePlan.vocWork;
                }
                grammarSkillsContent.push(skillObj);
              }
            }
          });
        }
        if (functionalSkillsContent.length > 0
          || languageSkillsContent.length > 0
          || grammarSkillsContent.length > 0) {
          skillArr.push({
            skillTitleId: item._id,
            title: values[indexLanguage],
            skills: {
              functional: functionalSkillsContent,
              language: languageSkillsContent,
              grammar: grammarSkillsContent,
            },
            createdAt: item.created_at,
          });
        }
      });
      const sortedArr = skillArr.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      setContent(sortedArr);
      setLoading(false);
    });
  };

  const fetchGroup = async () => {
    const groupRes = await groupServices.getGroupById(groupId);
    setVocInterests({
      news: !!groupRes.coursePlan?.vocInterests?.includes('news'),
      environment: !!groupRes.coursePlan?.vocInterests?.includes('environment'),
      economy: !!groupRes.coursePlan?.vocInterests?.includes('economy'),
      politics: !!groupRes.coursePlan?.vocInterests?.includes('politics'),
      art: !!groupRes.coursePlan?.vocInterests?.includes('art'),
      sport: !!groupRes.coursePlan?.vocInterests?.includes('sport'),
      travelling: !!groupRes.coursePlan?.vocInterests?.includes('travelling'),
      education: !!groupRes.coursePlan?.vocInterests?.includes('education'),
      leisure: !!groupRes.coursePlan?.vocInterests?.includes('leisure'),
    });
    setVocWork({
      meetings: !!groupRes.coursePlan?.vocWork?.includes('meetings'),
      presentations: !!groupRes.coursePlan?.vocWork?.includes('presentations'),
      negotiations: !!groupRes.coursePlan?.vocWork?.includes('negotiations'),
      emails: !!groupRes.coursePlan?.vocWork?.includes('emails'),
      telephoning: !!groupRes.coursePlan?.vocWork?.includes('telephoning'),
    });
    setVocPro({
      logistics: !!groupRes?.coursePlan?.vocPro?.includes('logistics'),
      sales: !!groupRes.coursePlan?.vocPro?.includes('sales'),
      marketing: !!groupRes.coursePlan?.vocPro?.includes('marketing'),
      finance: !!groupRes.coursePlan?.vocPro?.includes('finance'),
      legal: !!groupRes.coursePlan?.vocPro?.includes('legal'),
      engineering: !!groupRes.coursePlan?.vocPro?.includes('engineering'),
      production: !!groupRes.coursePlan?.vocPro?.includes('production'),
      quality: !!groupRes.coursePlan?.vocPro?.includes('quality'),
      it: !!groupRes.coursePlan?.vocPro?.includes('it'),
      hr: !!groupRes.coursePlan?.vocPro?.includes('hr'),
    });
    if (groupRes?.coursePlan?.formationContent) setContentIds(groupRes.coursePlan.formationContent);
    if (groupRes?.coursePlan?.specificSkills) setSpecificSkills(groupRes.coursePlan.specificSkills);
    setGroup(groupRes);
  };

  useEffect(() => {
    setLoading(true);
    fetchGroup();
    setLoading(false);
  }, [groupId]);

  useEffect(() => {
    setLoading(true);
    fetchSkills();
    setLoading(false);
  }, [language, level, group]);

  const handleChange = (value) => (e) => {
    if (value === 'level') setLevel(e.target.value);
    if (value === 'language') setLanguage(e.target.value);
  };

  useEffect(() => {
    switch (group.level) {
      case 0:
        setLevel('A0');
        break;
      case 1:
        setLevel('A1');
        break;
      case 2:
        setLevel('A2');
        break;
      case 3:
        setLevel('B1');
        break;
      case 4:
        setLevel('B2');
        break;
      case 5:
        setLevel('C1');
        break;
      case 6:
        setLevel('C2');
        break;
      default:
        setLevel('A0');
        break;
    }
  }, [group]);

  const downloadPdf = () => {
    groupServices.getCoursePlan(groupId).then((res) => {
      const courseInfos = res;
      let contentTitles = [];
      const specificSkillsArr = res.coursePlan.specificSkills;
      if (courseInfos !== undefined && courseInfos.coursePlan.formationContent !== undefined) {
        const arr = [];
        let filteredContentTitles = [];
        courseInfos.coursePlan.formationContent.forEach((item) => {
          arr.push(...item.skillTitle);
        });
        const ids = arr.map((item) => item._id);
        filteredContentTitles = arr.filter(({ _id }, index) => !ids.includes(_id, index + 1));
        contentTitles = [...filteredContentTitles];
        contentTitles.forEach((contentTitle) => {
          const formatedContent = [];
          contentTitle.skills.forEach((contentId) => {
            courseInfos.coursePlan.formationContent.forEach((contentObj) => {
              if (contentId === contentObj._id) {
                formatedContent.push(contentObj);
              }
            });
          });
          contentTitle.formatedContent = formatedContent;
        });
      }
      generatePDF(courseInfos, contentTitles, specificSkillsArr);
    });
  };

  return (
    <>
      {group !== undefined
        ? (
          <div>
            <div className={classes.top}>
              <div className={classes.select}>
                <div>
                  <InputLabel id="level">Level</InputLabel>
                  <Select
                    labelId="level"
                    style={{
                      backgroundColor: '#FFF',
                    }}
                    value={level}
                    label="Level"
                    disabled
                  // onChange={handleChange('level')}
                    variant="outlined"
                  >
                    <MenuItem value="A1">A1</MenuItem>
                    <MenuItem value="A2">A2</MenuItem>
                    <MenuItem value="B1">B1</MenuItem>
                    <MenuItem value="B2">B2</MenuItem>
                    <MenuItem value="C1">C1</MenuItem>
                    <MenuItem value="C2">C2</MenuItem>
                  </Select>
                </div>
                <div>
                  <InputLabel id="language">Language</InputLabel>
                  <Select
                    id="language-select"
                    value={language}
                    label="Language"
                    onChange={handleChange('language')}
                    variant="outlined"
                    style={{ backgroundColor: 'white', marginRight: '15px' }}
                  >
                    <MenuItem value="EN">English</MenuItem>
                    <MenuItem value="FR">Français</MenuItem>
                    {/* <MenuItem value="EN">Deutsch</MenuItem>
                    <MenuItem value="EN">Luxembourgish</MenuItem>
                    <MenuItem value="EN">Italiano</MenuItem>
                    <MenuItem value="EN">中国人</MenuItem> */}
                  </Select>
                </div>
              </div>
              <Button
                variant="contained"
                color="primary"
                component={Link}
                to="/skills"
                disableElevation
              >
                Manage global skills
              </Button>
            </div>
            <NeedsDialog open={open} setOpen={setOpen} group={group} />
            {content !== undefined && content.length > 0 && group !== undefined && loading === false
              ? (
                <>
                  <Typography style={{ marginTop: '50px', marginBottom: '15px' }}>Choose skills</Typography>
                  <Divider style={{ marginBottom: '30px' }} />

                  <DisplayContent
                    content={content}
                    group={group}
                    groupId={groupId}
                  // handleFormationContent={handleFormationContent}
                    contentIds={contentIds}
                    setContentIds={setContentIds}
                  />
                </>
              )
              : <Loading />}
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginTop: '50px',
                marginBottom: '15px',
              }}
            >
              <Typography>Manage needs</Typography>
              <Button
                variant="contained"
                color="primary"
                disableElevation
                onClick={() => setOpen(true)}
              >
                See students needs
              </Button>
            </div>
            <Divider style={{ marginBottom: '30px' }} />
            <NeedsSelection
              group={group}
              vocPro={vocPro}
              setVocPro={setVocPro}
              vocInterests={vocInterests}
              setVocInterests={setVocInterests}
              vocWork={vocWork}
              setVocWork={setVocWork}
            />
            <SpecificSkills
              specificSkills={specificSkills}
              setSpecificSkills={setSpecificSkills}
              language={language}
              level={level}
              group={group}
            />
            <Fab
              color="primary"
              aria-label="comment"
              style={styleComment}
              onClick={() => toogleSidebar()}
            >
              <CommentIcon />
            </Fab>
            <Fab
              color="primary"
              aria-label="edit"
              style={style}
              onClick={() => updateCoursePlan(group.coursePlan._id, contentIds, vocPro, vocInterests, vocWork)}
            >
              <SaveIcon />
            </Fab>
            <Fab
              color="primary"
              aria-label="pdf"
              style={stylepdf}
              onClick={() => downloadPdf()}
            >
              <PictureAsPdfIcon />
            </Fab>
            <SidebarComment />
          </div>
        )
        : <CircularProgress />}
    </>
  );
};

function mapState(state) {
  const groupId = state.group.selectedGroup._id;
  const groupState = state.group;
  const dataform = state.form[`group_${state.group.selectedGroup._id}`];
  return { groupId, groupState, dataform };
}

const actionCreators = {
  setSidebarState: uiActions.sidebarState,
};

const connectedContent = connect(mapState, actionCreators)(Content);

export default withRouter(connectedContent);
